module.exports = __webpack_public_path__ + "img/hand.85e95e36.png";